module.exports = __webpack_public_path__ + "static/media/1POLICY19.62c558bc.jpg";